<template>
  <div class="my">
    <div class="my-approval" id="my-approval" v-cloak>
      <span>您还未通过实名认证,</span>
      <a @click="gotoApproval">请立即认证!</a>
      <img class="fr" @click="closeappro()" src="/static/img/user/my/close.png">
    </div>
    <div class="my-approval" id="my-approval2" v-cloak>
      <span>您已认证,还需继续完善信息</span>
      <a @click="gotoApproval">去完善</a>
      <img class="fr" @click="closeappro()" src="/static/img/user/my/close.png">
    </div>
    <div class="user-my-f1">
      <!--<img class="user-my-user" @click="uploadUserImage" :src="getImg()">-->
      <img class="user-my-user"  :src="getImg()">
      <div class="ms">
        <div class="user-my-status">{{loginNameOrApprovalStatus}}</div>
        <div class="user-my-mobile">{{mobile}}</div>
      </div>
    </div>
    <div class="my-content">
      <div @click="gotoViewAndCreateMySign" class="my-f2">
        <img class="fl mymenuimg" src="/static/img/user/my/mysign.png">
        <span>我的签名</span>
        <hr>
      </div>
      <div @click="gotoViewAndBuyMyCombo" class="my-f2">
        <img class="fl mymenuimg" src="/static/img/user/my/mycombo.png">
        <span>我的套餐</span>
        <hr>
      </div>
      <div @click="gotoViewAndCreateMyContact" class="my-f2">
        <img class="fl mymenuimg" src="/static/img/user/my/myper.png">
        <span>我的联系人</span>
      </div>
    </div>
    <div @click="gotoAccountSecurity" class="my-content">
      <div class="my-f2">
        <img class="fl mymenuimg" src="/static/img/user/my/myacount.png">
        <span>账户安全</span>
      </div>
    </div>

    <div class="qrcode">
        <img src="/static/img/user/my/kefu.png" alt="">
        <span>客服微信：tsa_888</span>
    </div>
    <div class="userlogout">
      <mt-button class="login-btn" size="large" type="primary" @click="userlogout()">退出</mt-button>
    </div>

  </div>
</template>

<script>
  import {Toast, MessageBox} from 'mint-ui';
  import { userStatus, userStatusObj } from '@/config/userStatus'

  export default {
    data () {
      return {
        loginNameOrApprovalStatus: '',
        status: 0,
        mobile: '',
        photoId: 0,
        email: "未绑定",
        attestation:'',
      }
    },
    methods: {
      uploadUserImage:function () {
        this.$router.push({
          path: '/my/imagetallor',
          name: 'imagetallor',
          query:{
            photoId:this.photoId
          }
        })
      },
      gotoViewAndBuyMyCombo: function () {
        this.$router.push({
          path: '/combo/mycombo',
          name: 'mycombo'
        })
      },
      gotoApproval: function () {
        // userStatus(this.status)
        userStatus(this.status, ['0'], () => {
          if (this.status === '0') {
            this.$router.push({
                path: '/realName',
            })
          }
        })
        var cusType = localStorage.getItem("cusType");
      	if(cusType=="2"){
      		Toast("该帐号只可企业实名认证");
      		return;
      	}
        return
        // 0未认证 1个人认证 2正常企业认证待审核 3企业已认证需要完善信息 4完善信息待审核 5正常企业认证被拒绝（已经不存在了） 6完善信息审核被拒绝（企业） 7企业认证成功 8个人已认证需要完善信息
      },
      gotoAccountSecurity: function () {
        this.$router.push({
          path: '/my/myAccount',
          name: 'myAccount'
        })
        // var test = '/api/login';
        // window.location.href=process.env.USER_CENTER+'/user/association?redirectUrl='+test
      },
      gotoViewAndCreateMyContact: function () {
        this.$router.push({
          path: '/my/mycontact',
          name: 'mycontact'
        })
      },
      _initGetUser: function () {
        var that = this;
        var _mainIndex_Url = domain("_accountInfo"); //个人中心数据
        this.$http.post(
          _mainIndex_Url,
          {emulateJSON: true}
          )
          .then(function (response) {
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              var returnDate = response.data.data;
              console.log(returnDate);
              var approveStatus = returnDate.approveStatus;
              that.status = approveStatus;
              console.log(that.status)
              console.log('------------that.status-----------')
              var approtopid = document.getElementById("my-approval");
              var approtopid2 = document.getElementById("my-approval2");
              // if(that.status!=1){
              //   //that.approvalFlag=true;

              // }else{
              //   //that.approvalFlag=false;

              // }

              // 0 未认证 （ 未认证 ） 1 个人认证（ 已认证 ） 2 正常企业认证待审核( 基础信息审核中 ) 3 企业已认证需要完善信息（ 已认证待完善 ） 4 完善信息待审核( 认证信息审核中 ) 5 正常企业认证被拒绝（ 基础信息已拒绝 ） 6 完善信息审核被拒绝（ 认证信息已拒绝 ） 7 企业认证成功（ 已认证 ） 8 个人已认证需要完善信息（ 已认证待完善 ßß）
              if (approveStatus == '1' || approveStatus == '7') {
                approtopid.style.display="none";
                this.loginNameOrApprovalStatus = returnDate.loginName;
              } else if (approveStatus == '3' || approveStatus == '4'  || approveStatus == '6') {
                approtopid.style.display="none";
                approtopid2.style.display="block";
                // this.loginNameOrApprovalStatus = userStatusObj[that.status].clientName;
                this.loginNameOrApprovalStatus = returnDate.loginName;
              } else if(approveStatus == '8'){
                approtopid.style.display="none";
                approtopid2.style.display="block";
                // this.loginNameOrApprovalStatus = userStatusObj[that.status].clientName;
                this.loginNameOrApprovalStatus = returnDate.loginName;
              } else {
                approtopid.style.display="block";
                this.loginNameOrApprovalStatus = '未认证';
              }
            //   var _mobile = returnDate.ssouser.loginCord;
            this.mobile = returnDate.loginCode;
              ;
              this.photoId = returnDate.photoId;
            //   this.email = returnDate.vo.email;
            } else {
              Toast(msg)
            }
          }, function (error) {
            //Toast("数据获取响应异常.");
          }).catch(function (response) {
          //Toast("数据获取响应异常.");
        });
      },
      getImg: function () {
        if (this.photoId == 0) {
          return "/static/img/contract/user1.png";
        } else {
          var url = domain("_imgView") + this.photoId;
          return url;
        }
      },
      gotoViewAndCreateMySign: function () {
        this.$router.push({
          path: '/user/mySign',
          name: 'mySign'
        })
      },
      userlogout: function () {
        window.location.href='/api/logout';
        // this.$http.post(
        //     domain("_logout")
        //   )
        //   .then(function (response) {
        //     /*this.$router.push({
        //       path: '/'
        //     })*/
        //     window.location.href = process.env.USER_CENTER + '/login?redirectUrl=http://www.1sign.cn/mobile/toindex.do#page1/1'
        //   }, function (error) {
        //     console.log(error);
        //   })
      },
      closeappro:function () {
        //this.approvalFlag=false;
        var approtopid = document.getElementById("my-approval");
        approtopid.style.display="none";
        var approtopid2 = document.getElementById("my-approval2");
        approtopid2.style.display="none";
      }
    },
    mounted: function () {
      this._initGetUser();
    }
  }
</script>
<style>
  .my {
    margin-bottom: 65px;
  }

  .my .my-approval {
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #f9edd7;
    display: none;
  }

  .my .my-approval img {
    width: 14px;
    margin: 15px 15px 0 0;
  }

  .my .my-approval a {
    color: #1f74d8;
  }

  .my .my-approval span {
    color: #997a3d;
  }

  .my .my-approval a, .my .my-approval span {
    font-size: 0.8rem;
  }

  .user-my-f1 {
    background-image: url("/static/img/centerbg.jpg");
  }

  .user-my-f1 {
    background-color: #ffffff;
    padding: 0 10px;
    text-align: center;
  }

  .user-my-user {
    width: 60px;
    height: 60px;
    border-radius: 100px;
    margin: 15px auto 0 auto;
  }

  .my .user-my-f1 .ms {
    padding-bottom: 10px;
  }

  .rarrow {
    width: 11px;
  }

  .user-my-f1 .rarrow {
    margin: 35px 0 0 0;
  }

  .user-my-status, .user-my-mobile {
    font-size: 0.9rem;
  }

  .user-my-status {
    color: #ffffff;
  }

  .user-my-mobile {
    color: #c1c1c1;
    margin-top: 5px;
  }

  .my-content {
    margin-top: 15px;
    background-color: #ffffff;
    padding: 0 10px;
  }

  .my-f2 {
    height: 50px;
    line-height: 41px;
  }

  .my-f2 span {
    font-size: 0.9rem;
    color: #7d7d7d;
    margin-top: 10px;
    display: inline-block;
  }

  .mymenuimg {
    width: 20px;
    margin: 21px 15px 0 0;
  }

  .rarrow {
    margin-top: 20px;
  }

  .userlogout {
    width: 90%;
    margin: auto;
    margin-top: 2rem;
  }
  [v-cloak] {
    display: none;
  }
  .qrcode{
    text-align: center;
  }
  .qrcode img{
    width: 100px;
    height: 100px;
    margin: 20px 0 5px;
  }
  .qrcode span{
    display:block;
    color:#7d7d7d;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/My.vue